import React from 'react';
import { InfoPopupWebProps } from '@v2/components/imageHandling/components/Header/components/InfoPopup/InfoPopupWeb';
import { deletePrompt, download, Popup } from '@helpers';
import InfoModal from '@v2/components/imageHandling/components/Header/components/InfoPopup/InfoModal';
import i18n from 'i18n-js';
import { useSelector } from 'react-redux';
import { selectCurrentImageDocumentContext } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';

export interface UseManageInfoPopupWebParams
  extends Pick<InfoPopupWebProps, 'images' | 'selectedIndex' | 'deleteImage' | 'scale' | 'font' | 'list' | 'setSelectedIndex' | 'C'> {}

export const useManageInfoPopupWeb = ({
  deleteImage,
  images,
  selectedIndex,
  font,
  scale,
  setSelectedIndex,
  C,
  list: listFromProps,
}: UseManageInfoPopupWebParams) => {
  const currentImageContext = useSelector(selectCurrentImageDocumentContext);

  const openInfoModal = () => {
    Popup({
      Component: (p: any) => <InfoModal {...{ triggerInfoModal: p.hide, C, images, selectedIndex, scale, font }} />,
    });
  };

  const list = listFromProps ?? [
    {
      title: i18n.t('Download Now'),
      icon: 'download',
      onPress: () => download({ images, selectedIndex }),
      color: 'Label/Light/Primary',
      width: 15,
      height: 18,
    },
    {
      title: i18n.t('Get Info'),
      icon: 'info',
      onPress: openInfoModal,
      color: 'Label/Light/Primary',
      width: 16,
      height: 16,
    },
    {
      title: i18n.t('Delete'),
      icon: 'remove',
      onPress: () =>
        deletePrompt({ images, selectedIndex, setSelectedIndex, deleteImage, imageContext: currentImageContext, onSuccessImageRemove: () => {} }),
      color: 'Chart/Light/Warning',
      width: 15,
      height: 17,
    },
  ];

  return { list };
};
